<template>
	<div>
		<div id="sector1" v-if="datetypes=='linear'" ref="sector">
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			type: [String, Number],
			datetype: String
		},
		name1: 'sector',
		data() {
			return {
				datetypes: this.datetype,
			}
		},
		mounted() {
			
		},
		updated() {

		},
		methods: {},
		watch: {},
		created() {}
	}
</script>

<style lang="less">
	#sector1 {
		width: 100%;
		height: 50vh;
		margin: 0 auto;
	}
</style>
